/* Cart drawer (snippets/cuba-cart-drawer.liquid). Opens from the header cart icon and after
   every add to cart: the Cuba cards call cbDrawer.afterAdd(), and Boost's product form is
   caught on its /cart/add XHR. Quantity, remove, top-up and the picks change the cart through
   the Cart API with the drawer section bundled in the response, then #cb-drawer-inner is
   swapped. Boost's own "added" popup and the header hover summary are hidden while it runs. */
(function () {
  if (window.cbDrawer) return;
  var drawer = document.getElementById('cb-drawer');
  if (!drawer) return;
  var SECTION = 'cuba-cart-drawer';
  var panel = drawer.querySelector('.cb-drawer__panel');
  var lastFocus = null;
  document.documentElement.classList.add('cb-drawer-on');

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function inner() { return document.getElementById('cb-drawer-inner'); }
  function isOpen() { return drawer.classList.contains('is-open'); }

  function syncCount() {
    var el = inner();
    if (!el) return;
    var n = el.getAttribute('data-count');
    document.querySelectorAll('.header-cart__count').forEach(function (c) { c.textContent = n; });
  }
  function render(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('cb-drawer-inner');
    var cur = inner();
    if (!fresh || !cur) return;
    var body = cur.querySelector('.cb-drawer__body');
    var top = body ? body.scrollTop : 0;
    var picks = cur.querySelector('.cb-dpicks__list');
    var left = picks ? picks.scrollLeft : 0;
    cur.replaceWith(document.importNode(fresh, true));
    var nb = inner().querySelector('.cb-drawer__body');
    if (nb) nb.scrollTop = top;
    var np = inner().querySelector('.cb-dpicks__list');
    if (np) np.scrollLeft = left;
    syncCount();
  }
  function busy(on) { drawer.classList.toggle('is-busy', on); }
  function refresh() {
    return fetch(root() + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { render(j && j[SECTION]); })
      .catch(function () {});
  }
  function showError(msg) {
    var el = inner() && inner().querySelector('[data-cb-error]');
    if (el && msg) { el.textContent = msg; el.hidden = false; }
  }
  function post(path, data) {
    data.sections = SECTION;
    data.sections_url = window.location.pathname;
    busy(true);
    return fetch(root() + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(data)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    }).then(function (j) {
      if (j.sections && j.sections[SECTION]) render(j.sections[SECTION]);
      else return refresh();
    }).catch(function (err) {
      return refresh().then(function () { showError((err && err.description) || drawer.getAttribute('data-error')); });
    }).then(function () { busy(false); });
  }
  function change(line, qty) {
    if (drawer.classList.contains('is-busy') || !line) return;
    post('cart/change.js', { line: line, quantity: Math.max(0, qty || 0) });
  }
  function add(id, qty) {
    if (drawer.classList.contains('is-busy') || !id) return;
    post('cart/add.js', { items: [{ id: id, quantity: qty || 1 }] });
  }

  function focusables() {
    return Array.prototype.filter.call(
      panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; }
    );
  }
  function open() {
    if (isOpen()) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    void drawer.offsetWidth; // let the hidden -> shown change paint so the slide-in runs
    drawer.classList.add('is-open');
    document.documentElement.classList.add('cb-drawer-lock');
    setTimeout(function () {
      var c = panel.querySelector('.cb-drawer__close');
      (c || panel).focus();
    }, 60);
  }
  function close() {
    if (!isOpen()) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('cb-drawer-lock');
    setTimeout(function () { if (!isOpen()) drawer.hidden = true; }, 350);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function afterAdd(res) {
    if (res && res.sections && res.sections[SECTION]) {
      render(res.sections[SECTION]);
      open();
      return Promise.resolve();
    }
    return refresh().then(open);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var opener = t.closest('.header-cart > a, [data-cb-drawer-open]');
    if (opener && !e.metaKey && !e.ctrlKey && !e.shiftKey) { e.preventDefault(); open(); return; }
    if (!drawer.contains(t)) return;
    if (t.closest('[data-cb-drawer-close]')) { e.preventDefault(); close(); return; }
    var q = t.closest('[data-cb-line]');
    if (q) { e.preventDefault(); change(parseInt(q.getAttribute('data-cb-line'), 10), parseInt(q.getAttribute('data-cb-qty'), 10)); return; }
    var a = t.closest('[data-cb-add-id]');
    if (a) { e.preventDefault(); add(parseInt(a.getAttribute('data-cb-add-id'), 10), 1); }
  });
  drawer.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-cb-line-input]');
    if (!input) return;
    var v = parseInt(input.value, 10);
    change(parseInt(input.getAttribute('data-cb-line-input'), 10), isNaN(v) ? 0 : v);
  });
  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // Boost's product form and quick buy post to /cart/add.js with jQuery (XHR).
  var xo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (/\/cart\/add(\.js)?(\?|$)/.test(String(url))) {
      this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) afterAdd(); });
    }
    return xo.apply(this, arguments);
  };
  // A page restored from the back/forward cache may show an old cart.
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  window.cbDrawer = { enabled: true, open: open, close: close, refresh: refresh, afterAdd: afterAdd, add: add };
})();
